/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Install_DismissInputs */

const cs_pwa_install_dismiss = /** @type {(inputs: Pwa_Install_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teď ne`)
};

const en_pwa_install_dismiss = /** @type {(inputs: Pwa_Install_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not now`)
};

/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Pwa_Install_DismissInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pwa_install_dismiss = /** @type {((inputs?: Pwa_Install_DismissInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Install_DismissInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pwa_install_dismiss(inputs)
	return cs_pwa_install_dismiss(inputs)
});